import { CustomElement, resolve } from 'aurelia';
import { AccountService, AdminService, CalendarService, DiagnosticsService, FeedbackService, SourceAdminService, ImageCacheAdminService, UsersReportAdminService, ScraperReportAdminService, DailyReleasesAdminService, ConfigAdminService, LogsAdminService, AnalyticsAdminService } from '../../services';
import template from './admin-menu.html';

// Admin-only hamburger dropdown in the header: Log toggle (with entry count), manual Refresh,
// a Feedback on/off toggle (shows/hides the floating feedback button for everyone), a Sources
// panel (per-source on/off), and Sign out. Visibility (isAdmin) and all actions live in
// AdminService; the disabled states track CalendarService load flags and the count comes from
// DiagnosticsService. The admin Sign out is hidden for Auth0-authenticated admins, since the
// account menu owns the federated logout.
export class AdminMenuElement {
  readonly admin: AdminService = resolve(AdminService);
  readonly calendar: CalendarService = resolve(CalendarService);
  readonly diagnostics: DiagnosticsService = resolve(DiagnosticsService);
  readonly account: AccountService = resolve(AccountService);
  readonly feedback: FeedbackService = resolve(FeedbackService);
  readonly sourceAdmin: SourceAdminService = resolve(SourceAdminService);
  readonly imageCacheAdmin: ImageCacheAdminService = resolve(ImageCacheAdminService);
  readonly usersReport: UsersReportAdminService = resolve(UsersReportAdminService);
  readonly scraperReport: ScraperReportAdminService = resolve(ScraperReportAdminService);
  readonly dailyReleases: DailyReleasesAdminService = resolve(DailyReleasesAdminService);
  readonly configAdmin: ConfigAdminService = resolve(ConfigAdminService);
  readonly logsAdmin: LogsAdminService = resolve(LogsAdminService);
  readonly analyticsAdmin: AnalyticsAdminService = resolve(AnalyticsAdminService);

  // Opens the source-management panel and closes the dropdown.
  async openSources(): Promise<void> {
    this.admin.closeAdminMenu();
    await this.sourceAdmin.openPanel();
  }

  // Opens the image-cache management panel and closes the dropdown.
  async openImageCache(): Promise<void> {
    this.admin.closeAdminMenu();
    await this.imageCacheAdmin.openPanel();
  }

  // Opens the users report panel and closes the dropdown.
  async openUsersReport(): Promise<void> {
    this.admin.closeAdminMenu();
    await this.usersReport.openPanel();
  }

  // Opens the signup-funnel analytics panel and closes the dropdown.
  async openAnalytics(): Promise<void> {
    this.admin.closeAdminMenu();
    await this.analyticsAdmin.openPanel();
  }

  // Opens the scraper report panel and closes the dropdown.
  async openScraperReport(): Promise<void> {
    this.admin.closeAdminMenu();
    await this.scraperReport.openPanel();
  }

  // Opens the daily releases report panel and closes the dropdown.
  async openDailyReleases(): Promise<void> {
    this.admin.closeAdminMenu();
    await this.dailyReleases.openPanel();
  }

  // Opens the configuration viewer panel and closes the dropdown.
  async openConfiguration(): Promise<void> {
    this.admin.closeAdminMenu();
    await this.configAdmin.openPanel();
  }

  // Opens the latest-log viewer panel and closes the dropdown.
  async openLogs(): Promise<void> {
    this.admin.closeAdminMenu();
    await this.logsAdmin.openPanel();
  }
}

export const AdminMenu = CustomElement.define({
  name: 'admin-menu',
  template,
  // Render in place so the absolutely-positioned .admin-menu keeps its header anchor.
  containerless: true
}, AdminMenuElement);
